<template>
  <div class="login-head">
    <div><img class="img" @click="()=>{this.$router.push('/')}" src="../../../images/logo.png" alt="" /></div>
    <div class="title">欢迎注册百生跃！</div>
    <div class="go-register">已有账号，立即<span @click="login">登录</span></div>
  </div>
</template>

<script>
export default {
  methods: {
    login(){
      this.$router.push('./login')
    }
  },
}
</script>

<style lang="less" scoped>
.login-head{
    width: 1200px;
    height: 117px;
    background: #003871;
    border-radius: 9px 9px 0px 0px;
    display: flex;
    .img{
      width: 157px;
      height: 50px;
      margin-left: 107px;
      margin-top: 37px;
      cursor: pointer;
    }
    .title{
        width: 480px;
        height: 52px;
        font-size: 40px;
        font-weight: 700;
        text-align: left;
        color: #ffffff;
        letter-spacing: 20px;
        margin-left: 105px;
        margin-top: 33px;
    }
    .go-register{
        height: 19px;
        font-size: 14px;
        text-align: left;
        color: #ffffff;
        letter-spacing: 1px;
        margin-left: 105px;
        margin-top: 67px;
        span{
          cursor: pointer;
          color: #ffbb00;
        }
    }
}
</style>